import { Card } from 'react-bootstrap';
import styled from 'styled-components';

const StyledCard = styled(Card)`
    height: 75vh;
`;

export default StyledCard;
